export default amount => amount === 0 ? 'tradicional' : `${amount}%`;